<template>
  <NuxtPage
    :keepalive="{
      include: keepAliveIncludePage
    }"
  />
  <!-- 确认按钮弹出框-授权 -->
  <DialogAuthConfirm />
  <!-- 充值提示弹窗 -->
  <RechargeTipsPopup />
  <!-- 免费券弹窗 -->
  <FreeCardPopup />
  <!-- 充值弹窗 -->
  <RechargePopup />
  <!-- webView -->
  <WebViewPopup />
  <!-- 下载App提示弹窗 -->
  <DownloadAppTipsPopup />
  <!-- 登录弹窗 -->
  <Login />
  <!-- 最小化房间 -->
  <MinimizeRoom v-if="isMounted" />
  <!-- 礼物横幅 -->
  <GiftBanner v-if="isMounted" />
  <!-- 全局操作弹窗 -->
  <GlobalActionSheet v-if="isMounted" />

  <!-- 文本为SEO使用，请忽略 -->
  <div class="description-content">
    Cocco Meet video chat with new people online ✔️1V1 video calls ✔️1v1 chats
    ✔️ make new friends ✔️ find your next date. In Cocco, you can choose someone
    for video dating, enjoy a sweet relationship, and accompany you to eliminate
    loneliness and worries. You will have a wonderful time.
  </div>
</template>

<script setup lang="ts">
import qs from 'qs'
import '@vant/touch-emulator' // 桌面端适配,将 mouse 事件转换成对应的 touch 事件
import RechargePopup from '@/pages/Recharge/components/RechargePopup.vue'
import GlobalActionSheet from '@/components/ActionSheet/index.vue'

// const AsyncRechargePopup = defineAsyncComponent(
//   () => import('@/pages/Recharge/components/RechargePopup.vue')
// )

// const userStore = useUserStore()
const loginStore = useLoginStore()
const publicStore = usePublicStore()
const { keepAliveIncludePage } = storeToRefs(publicStore)
const languageStore = useLanguageStore()

// 语言初始化
languageStore.initLanguage()

const { isMounted } = useIsMounted()

//#region 显示与隐藏页面的hooks，存到public store
usePageVisibility((isVisible) => {
  publicStore.setIsPageVisible(isVisible)
  // 网页切换到后台或者手机处于息屏状态监听
  // if (localStorage.getItem('ticket') && localStorage.getItem('loginInfo')) {
  //   if (document.hidden) {
  //     userStore.changeManOnline(2) // 标志下线
  //   } else {
  //     userStore.changeManOnline(1) // 标志上线
  //   }
  // }
})

//#endregion

//#region 监听路由，切换页面动态设置SEOMeta
const route = useRoute()
const router = useRouter()
router.afterEach(() => {
  // 加定时器是想延迟跳转到目标页面再设置
  setTimeout(() => {
    usePrivateSeoMeta()
  }, 0)
})
usePrivateSeoMeta() // 刷新页面不会触发路由监听，所以主动调一次
//#endregion

//#region 浏览器  client端才会走的逻辑
if (process.client) {
  localStorage.removeItem('login') // 1.1.4 2024-07-30 用于移除弃用缓存
  localStorage.removeItem('language') // 1.1.4 2024-07-30 用于移除弃用缓存

  //  && common.checkVersion().app
  if (route.path === '/roomApp/audio' || route.path === '/roomApp/live') {
    // 在客户端打开房，逻辑性逻辑在语音房使用
  } else {
    // 初始化登录
    loginStore.initLogin().then(() => {
      // 埋点
      eventTracking.eventLog(eventTracking.eventId.open)
    })
  }

  //#endregion

  //#region 保存URL参数
  /**
   * 链接带参进入
   * &source=来源
   * &country=国家代码
   * */
  /**
   * 链接带参进入
   * &utm_campaign=广告系列ID
   * &country=国家代码
   * */
  // 如果url有国家代码进来就作为默认国家。
  // 有时候推广会传国家代码以外的值进来，这种直接忽略，目前有 allcountry
  const country = common.getQueryVariable('country')
  if (country && country !== 'allcountry') {
    loginStore.setUTMCountry(country)
  }

  // 如果有广告系列ID进来，就存到pinia，然后重定向此页面
  const utmCampaign = common.getQueryVariable('utm_campaign')
  if (utmCampaign) {
    loginStore.setUTMCampaign(utmCampaign)
  }

  // 如果有邀请码进来，就存到pinia，然后重定向此页面
  const invitationCode = common.getQueryVariable('invitationCode')
  if (invitationCode) {
    loginStore.setInvitationCode(invitationCode)
  }

  //  谷歌重定向登录成功回来走流程
  if (/code|token/.test(location.hash)) {
    // 执行谷歌回调登录时间
    const loginData = qs.parse(location.hash)
    loginStore.googleLoign(loginData)
    // 执行重定向流程，utmCampaignSearch 是广告参数，是在谷歌登录之前存的，重定向回来拼接回去
    const utmCampaignSearch = localStorage.getItem('utmCampaignSearch') || ''
    utmCampaignSearch && localStorage.removeItem('utmCampaignSearch')
    const router = useRouter()
    router.replace('/' + utmCampaignSearch)
  }
}
//#endregion

onBeforeUnmount(() => {
  // socketStore.inSocket && socketStore.inSocket.destroy()
})
</script>

<style></style>
